import {
    mailTextConfig as sharedConfig,
    type MailTextConfigMap,
} from '@starjack/entities/mailConfiguration';
import Order from './pdfImages/order.jpg';
import Pickup from './pdfImages/pickup.jpg';
import Keycard from './pdfImages/keycard.jpg';
import Internal from './pdfImages/internal.jpg';
import ETicket from './pdfImages/eticket.jpg';
import Cancel from './pdfImages/cancel.jpg';
import KeycardProduced from './pdfImages/keycardProduced.jpg';
import TicketETicket from './pdfImages/ticketETicket.jpg';
import Activation from './pdfImages/activation.jpg';
import Recovery from './pdfImages/recovery.jpg';
import EmailChangeRequest from './pdfImages/emailChangeRequest.jpg';
import EmailChangeConfirmation from './pdfImages/emailChangeConfirmation.jpg';

const imageMap: Record<string, string> = {
    Order,
    TicketKeycard: Keycard,
    TicketPickup: Pickup,
    TicketBarcode: ETicket,
    TicketETicket: TicketETicket,
    TicketInternal: Internal,
    TicketCancellation: Cancel,
    KeycardProduced,
    Activation,
    Recovery,
    EmailChangeRequest,
    EmailChangeConfirmation,
};

export const mailTextConfig: MailTextConfigMap = Object.fromEntries(
    Object.entries(sharedConfig).map(([key, group]) => [
        key,
        { ...group, image: imageMap[key] ?? group.image },
    ])
);

export type MailTextConfig = typeof mailTextConfig;
export type MailTextConfigKey = keyof typeof sharedConfig;
